import {useEffect, useState} from 'react'

import Select from 'react-select'
import {FormLabel} from 'react-bootstrap'
import {getLaunchesPartners} from '../../../../../services/urbit-gis'

export function GetDevelopersChosen({SetValueInput, valueInput, disabled = false}) {
  let valueArray = []

  const [value, setValue] = useState<number | ''>('')
  const [options, setOptions] = useState<Array<{value: number | ''; label: string}>>([])

  useEffect(() => {
    if (valueInput !== undefined && valueInput !== null && valueInput !== '') {
      setValue(Number(valueInput))
    } else {
      setValue('')
    }
  }, [valueInput])

  useEffect(() => {
    async function load() {
      const result = await getLaunchesPartners(1, 5500)
      if (result) {
        let valueArray = []
        valueArray.push({value: '', label: '--selecione--'})
        result.data.map((item) => {
          valueArray.push({value: item.id_developer_orulo, label: item.nome})
          return []
        })
        setOptions(valueArray)
      }
    }
    load()
  }, [])

  if (!options) {
    return (
      <>
        <div className='col-form-label'>
          <FormLabel className='form-label'>Construtora</FormLabel>
          <Select
            options={valueArray}
            onChange={(e) => {
              const selectedValue = e?.value ?? ''
              setValue(selectedValue === '' ? '' : Number(selectedValue))
            }}
            value={valueArray.filter((e) => e.value)[0]}
            name='id_developer'
            placeholder='Construtora'
          />
        </div>
      </>
    )
  }

  return (
    <>
      <div className='form-group'>
        <FormLabel className='form-label'>Construtora</FormLabel>
        <Select
          value={
            options.find((e) => {
              return e.value === value
            }) || null
          }
          options={options}
          onChange={(e) => {
            const selectedValue = e?.value ?? ''
            const numericValue = selectedValue === '' ? '' : Number(selectedValue)
            setValue(numericValue)
            SetValueInput(numericValue)
          }}
          name='id_developer'
          placeholder='Construtora'
          isDisabled={disabled}
        />
      </div>
    </>
  )
}
